import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./Dashboard.css";
import DashboardRefresh from "./DashboardRefresh";
import { useActivityLogger } from "../../hooks/useActivityLogger";

const DashboardHome = () => {
  const { sessionUserBoValue } = useActivityLogger();
  const reportId = 2;
  //console.log("sessionUserBoValue", sessionUserBoValue);
  const [reportInfo, setReportInfo] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.NODE_ENV === "development"
          ? `http://localhost:9000/mrunner_api/getPowerBIToken`
          : `${window.location.protocol}//${window.location.host}/mrunner_api/getPowerBIToken`,
        { r_id: reportId }
      );
      // console.log("powerBI token", response);
      setReportInfo(response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // console.log("models", models);
  const embedConfig = useMemo(() => {
    const email = sessionUserBoValue?.email || null;
    const id = sessionUserBoValue?.userCredentials?.id || null;

    const filters = [];

    if (email) {
      filters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "public dim_userrole_details",
          column: "username",
        },
        operator: "In",
        values: [email],
      });
    }
    if (id) {
      filters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "public dim_userrole_details",
          column: "uid",
        },
        operator: "In",
        values: [id],
      });
    }

    return {
      type: "report",
      id: reportInfo?.reportId,
      embedUrl: reportInfo?.embedUrl,
      tokenType: models.TokenType.Embed,
      accessToken: reportInfo?.finalToken,
      pageView: "actualSize",
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: models.LayoutType.FitToWidth,
      },
      filters,
    };
  }, [
    reportInfo,
    sessionUserBoValue?.email, //don't remove ? from here
    sessionUserBoValue?.userCredentials?.id, //don't remove ? from here
  ]);

  const refreshDashboard = () => {
    setReportInfo(null);
    fetchData();
  };

  return (
    <div
      style={{
        padding: "65px 0px 0px",
        height: "calc(100vh - 64px)",
        width: "100%",
        position: "relative",
      }}
    >
      {reportInfo?.bearerToken && (
        <DashboardRefresh
          reportId={reportId}
          accessToken={reportInfo?.bearerToken}
          groupId={reportInfo?.workspaceId}
          datasetId={reportInfo?.datasetId}
          refreshDashboard={refreshDashboard}
        />
      )}
      {reportInfo && (
        <PowerBIEmbed
          embedConfig={embedConfig}
          eventHandlers={
            new Map([
              [
                "loaded",
                function () {
                  // console.log("Report loaded");
                },
              ],
              [
                "rendered",
                function () {
                  // console.log("Report rendered");
                },
              ],
              [
                "error",
                function (event) {
                  console.log(event.detail);
                },
              ],
            ])
          }
          cssClassName="powerbi-container"
        />
      )}
    </div>
  );
};

export default DashboardHome;
